import { errorHandler, CONST } from './depends'
import { oldWorkbenchWhitePaths } from '@/layout/container/const'
import pj from '@/../package.json'

// 路由切换鉴权
export default function startRouteCheck(router, authPaths, { jumpSwitchConfig, user } = {}) {
  if (authPaths) {
    authPaths = authPaths.map(auth => auth.path.toLocaleLowerCase())
    router.beforeEach((to, from, next) => {
      const path = `/${pj.name}/#${to?.path}`
      try {
        // 如果开启新工作台调整配置
        if (includePath(oldWorkbenchWhitePaths, path) && jumpSwitchConfig?.switch) {
          if (
            jumpSwitchConfig?.all ||
            jumpSwitchConfig?.departmentIds?.includes?.(user?.departmentId) ||
            jumpSwitchConfig?.userIds?.includes?.(user?.jobNumber)
          ) {
            window.location.href = window.location.href.replace('h5newcallcenter', 'qmove-customer-service-workbench')
            return next(false)
          }
        }
        if (noCheck(authPaths, to.path.toLocaleLowerCase())) {
          return next()
        }
        fail()
      } catch (e) {
        console.error(e)
        fail()
      }

      function fail() {
        errorHandler(CONST.noRouteAuth)
        next(false)
      }
    })
  }
}

// 不鉴权
function noCheck() {
  return true
}

function includePath(menus, path) {
  return !!menus.filter(menuPath => {
    // 与/im工作台冲突
    if (path.includes('/h5newcallcenter/#/im-')) return false
    return path.includes(menuPath)
  })?.length
}
